interface Config {
  api: {
    baseURL: string;
    timeout: number;
  };
  features: {
    enableFileUpload: boolean;
    maxFileSize: number; // in bytes
    anonymousDraftsEnabled: boolean;
  };
  auth0: {
    domain: string;
    clientId: string;
    audience?: string;
  };
  turnstile: {
    siteKey: string;
  };
  intercom: {
    appId: string;
  };
}

const config: Config = {
  api: {
    baseURL: process.env.REACT_APP_DRAWS_API_BASE_URL || 'http://localhost:8000',
    timeout: parseInt(process.env.REACT_APP_DRAWS_API_TIMEOUT || '600000', 10), // 10 minutes for large file operations
  },
  features: {
    enableFileUpload: process.env.REACT_APP_DRAWS_ENABLE_FILE_UPLOAD !== 'false',
    maxFileSize: parseInt(process.env.REACT_APP_DRAWS_MAX_FILE_SIZE || '2147483648', 10), // 2GB default
    anonymousDraftsEnabled: process.env.REACT_APP_DRAWS_ANONYMOUS_DRAFTS_ENABLED === 'true',
  },
  auth0: {
    domain: process.env.REACT_APP_DRAWS_AUTH0_DOMAIN || 'plxs-dev.au.auth0.com',
    clientId: process.env.REACT_APP_DRAWS_AUTH0_CLIENT_ID || 'whiJSOmiz9q2lwh8d5N7vLV3MtU7Gx4D',
    audience: process.env.REACT_APP_DRAWS_AUTH0_AUDIENCE || 'http://localhost:8000',
  },
  turnstile: {
    siteKey: process.env.REACT_APP_DRAWS_TURNSTILE_SITE_KEY || '',
  },
  intercom: {
    appId: process.env.REACT_APP_DRAWS_INTERCOM_APP_ID || 'js75ahv6',
  },
};

export default config;
